import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
//import { JwtHelperService } from '@auth0/angular-jwt';
import { MustMatch } from 'src/app/helpers/must-match.validator';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AuthGnxService } from 'src/app/services/authGnx/auth-gnx.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import { Plugins } from '@capacitor/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { ICheckUserAnswer } from 'src/app/interfaces/IAuth';
const { Storage } = Plugins;

export const TYPES_REGISTER = {
  phone: 'phone',
  email: 'email',
  document: 'document',
  iddoc: 'iddoc',
  username: 'username',
};

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit, OnDestroy {
  registerForm: FormGroup;
  captcha: string;
  phoneIndicators;
  LOADER_ID = 'register';
  userTypes: any;
  showCode = false;
  showUserType = false;
  error = '';
  phoneContact: any;
  apiWhatsapp: string = 'https://api.whatsapp.com/send?phone=';
  phoneIndicator = {
    indicator: environment.phoneIndicator,
    country: environment.country,
    code: environment.country,
  };
  types = {
    phone: { value: TYPES_REGISTER.phone, isRequired: false },
    email: { value: TYPES_REGISTER.email, isRequired: false },
    document: { value: TYPES_REGISTER.document, isRequired: false },
    username: { value: TYPES_REGISTER.username, isRequired: false },
  };

  registerType;
  registerUser$;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private remoteConfig: RemoteConfigService,
    private storageService: StorageService,
    public fireAuth: AngularFireAuth,
    private alertService: AlertService,
    private authGnx: AuthGnxService,
    private userService: UserService,
    private router: Router,
    private captchaService: CaptchaService,
    private loaderService: LoaderService,
    private utilsService: UtilsService,
    public languageService: LanguagesService
  ) {
    this.initConstructor();
  }

  initConstructor() {
    this.registerForm = this.formBuilder.group(
      {
        name: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(3),
            Validators.pattern('^[a-zA-Z ñÑáéíóúÁÉÍÓÚ]*$'),
          ]),
        ],
        lastname: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(3),
            Validators.pattern('^[a-zA-Z ñÑáéíóúÁÉÍÓÚ]*$'),
          ]),
        ],
        PhoneValidation: this.formBuilder.group(
          {
            indicator: [''],
            confirmIndicator: [''],
            phone: [
              '',
              Validators.compose([
                Validators.minLength(10),
                Validators.maxLength(10),
                Validators.pattern('^[0-9]*$'),
              ]),
            ],
            confirmPhone: [
              '',
              Validators.compose([
                Validators.minLength(10),
                Validators.maxLength(10),
                Validators.pattern('^[0-9]*$'),
              ]),
            ],
          },
          {
            validator: [
              MustMatch('phone', 'confirmPhone'),
              MustMatch('indicator', 'confirmIndicator'),
            ], // custom validation
          }
        ),
        PasswordValidation: this.formBuilder.group(
          {
            password: [
              '',
              Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(
                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$"
                ),
              ]),
            ],
            confirmPassword: ['', Validators.compose([Validators.required])],
          },
          {
            validator: MustMatch('password', 'confirmPassword'), // custom validation
          }
        ),
        email: [
          '',
          Validators.compose([
            Validators.minLength(8),
            Validators.pattern(
              "^[a-zA-Z0-9#$%&'*/=?^_+-`{|}~]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
          ]),
        ],
        confirmEmail: [
          '',
          Validators.compose([
            Validators.minLength(8),
            Validators.email,
            Validators.pattern(
              "^[a-zA-Z0-9#$%&'*/=?^_+-`{|}~]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
          ]),
        ],
        document: [
          '',
          Validators.compose([
            // Validators.required,
            Validators.minLength(4),
            Validators.pattern('^[a-zA-Z0-9]+$'),
          ]),
        ],
        documentType: ['', Validators.compose([Validators.required])],
        inscriptionCode: [
          '',
          Validators.compose([Validators.minLength(4), Validators.required]),
        ],
      },
      {
        validator: MustMatch('email', 'confirmEmail'),
      }
    );
  }

  ngOnDestroy(): void {}
  async ionViewDidEnter() {
    // this.initConstructor();
    var indicatorStorage = await this.storageService.get('phoneIndicators');
    if (indicatorStorage && indicatorStorage.length > 0) {
      console.log('indicatorStorage', indicatorStorage);

      this.phoneIndicators = indicatorStorage;
    } else {
      this.remoteConfig.getInfoApp().subscribe((data: any) => {
        if (data['phone-indicators']) {
          this.phoneIndicators = data['phone-indicators'];
          this.storageService.set('phoneIndicators', this.phoneIndicators);
        }
      });
    }
    await this.remoteConfig
      .getInfoApp()
      .toPromise()
      .then((res: any) => {
        console.log('++', res);
        this.phoneContact = res['phone-contact'];
      });

    this.apiWhatsapp = `${this.apiWhatsapp}${this.phoneContact}&text=¡Hola!`;

    await this.getUserType();
  }
  ionViewDidLeave() {
    this.registerForm.reset();
    this.showCode = false;
  }

  async ngOnInit() {}

  setValidations(register_type = TYPES_REGISTER.iddoc) {
    let type =
      register_type == TYPES_REGISTER.iddoc
        ? TYPES_REGISTER.document
        : register_type;
    console.log('setValidations type ', type);
    this.registerType = type;
    const validatorsTypes = {
      phone: [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(11),
        Validators.pattern('^[0-9]*$'),
      ],
      email: [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          "^[a-zA-Z0-9._%+!#$&'*/=?^`{|}~]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
        ),
        Validators.email,
      ] /*  */,
      document: [
        Validators.required,
        Validators.minLength(4),
        Validators.pattern('^[a-zA-Z0-9]+$'),
      ],
    };
    Object.keys(this.types).forEach((item) => {
      if (type == item) {
        this.types[type].isRequired = true;
        if (type == TYPES_REGISTER.phone) {
          this.phone.controls[item].setValidators([...validatorsTypes[item]]);
          this.phone.controls[item].updateValueAndValidity();
        } else {
          if (type == TYPES_REGISTER.username) {
            this.showCode = true;
            this.f.inscriptionCode.setValidators([
              Validators.required,
              Validators.minLength(4),
            ]);
            this.f.inscriptionCode.updateValueAndValidity();
          }

          if (type == TYPES_REGISTER.document) {
            this.registerForm.controls['documentType'].setValidators([
              Validators.required,
            ]);
            this.registerForm.controls['documentType'].updateValueAndValidity();
          }

          if (type != TYPES_REGISTER.username) {
            this.registerForm.controls[item].setValidators([
              ...validatorsTypes[item],
            ]);

            this.registerForm.controls[item].updateValueAndValidity();
          }
        }
      }
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  get phone() {
    return this.registerForm.controls.PhoneValidation as FormGroup;
  }

  get passwordField() {
    return this.registerForm.controls.PasswordValidation as FormGroup;
  }

  async getUserType() {
    const body = {
      app_id: environment.gluky.app_id,
    };
    this.authService.getRegisterConfigData(body).subscribe(async (res: any) => {
      this.userTypes = await res;
      res.forEach((item) => {
        if (item.opened_sign_in) {
          this.showUserType = true;
          this.registerForm.addControl(
            'userType',
            new FormControl('', Validators.required)
          );
          this.registerForm.updateValueAndValidity();
        }
      });
      if (!this.showUserType) {
        this.showCode = true;
      }
      this.setValidations(res[0].register_type);
      // this.setValidations(TYPES_REGISTER.username);
    });
  }

  userTypeSelect(event) {
    const value = event.target.value;
    if (value.opened_sign_in) {
      if (this.registerType != TYPES_REGISTER.username) {
        this.showCode = false;
        this.f.inscriptionCode = new FormControl('');
        this.registerForm.updateValueAndValidity();
      }
    } else {
      this.showCode = true;

      this.f.inscriptionCode.setValidators([
        Validators.required,
        Validators.minLength(4),
      ]);
    }
  }

  openChat() {
    window.location.href = this.apiWhatsapp;
  }

  keyPressNumber(event) {
    let rex = /^[0-9]*$/;
    let valid = rex.test(event.key);
    let inp = String.fromCharCode(event.keyCode);
    if (/^[0-9]*$/.test(inp) || valid) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  seePassword(input, icon) {
    input.type = input.type == 'text' ? 'password' : 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

  handleSuccess(captchaResponse: string) {
    this.captcha = captchaResponse;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  executeSave() {
    this.error = '';
    if (!this.registerForm.valid) {
      this.registerForm.markAllAsTouched();
      this.alertService.presentAlert(
        'Revisa que todos los campos esten llenos correctamente'
      );
      return;
    }
    this.loaderService.presentLoading(this.LOADER_ID);
    const containerCaptcha = document.getElementById('recaptcha-register');
    const id = Math.round(Math.random());
    containerCaptcha.insertAdjacentHTML(
      'afterbegin',
      `<div id='recaptcha-register${id}'></div>`
    );
    window['grecaptcha'].render(`recaptcha-register${id}`, {
      sitekey: this.captchaService.siteKey,
      callback: (token) => {
        this.registerUser(token);
        this.loaderService.cancelLoader(this.LOADER_ID);
        document.getElementById(`recaptcha-register${id}`).remove();
      },
      size: 'invisible',
    });
    window['grecaptcha'].execute();
  }

  selectDocumentType(event) {
    this.registerForm.controls.documentType.setValue(event.target.value);
  }

  async registerUser(token) {
    if (!this.f.email.value && !this.phone.controls.phone.value) {
      this.error = 'Debes agregar un teléfono o un email';
      return;
    }
    if (this.showCode && !this.f.inscriptionCode.value) {
      this.alertService.presentAlert('El código de inscripción es requerido');
      return;
    }

    this.loaderService.presentLoading(this.LOADER_ID);
    const body = {
      app_id: environment.gluky.app_id,
      username: this.f.inscriptionCode.value,
      name: String(this.f.name.value).trim(),
      last_name: String(this.f.lastname.value).trim(),
      phone: this.phoneIndicator.indicator + this.phone.controls.phone.value,
      country_code: String(this.phoneIndicator.code).toUpperCase(),
      email: String(this.f.email.value).toLowerCase(),
      password: this.passwordField.controls.password.value,
      iddoc_type: this.f.documentType.value,
      iddoc: this.f.document.value,
      register_code: this.f.inscriptionCode.value,
      captcha: token,
    };

    if (!this.phone.controls.phone.value) {
      delete body['phone'];
    }
    if (!this.f.email.value) {
      delete body['email'];
    }
    if (this.f.userType) {
      body['user_type'] = this.f.userType.value.user_type_id;

      if (!this.f.inscriptionCode.value) {
        delete body['register_code'];
        body['username'] = body['iddoc'];
      }
    }

    if (!this.f.document.value) {
      delete body['iddoc'];
      delete body['iddoc_type'];

      if (this.f.inscriptionCode.value) {
        body['username'] = body['register_code'];
      }
      if (!body['username']) {
        if (body.phone) {
          body['username'] = body['phone'];
        } else if (body.email) {
          body['username'] = body['email'];
        }
      }
    } else {
      body['iddoc'] = (this.f.document.value as string).toUpperCase();
    }

    const mail = body['email']
      ? body['email']
      : this.registerType == TYPES_REGISTER.phone
      ? `${body['phone']}@nomail.glukynet.com`.replace('+', '')
      : `${body['username']}@nomail.glukynet.com`;

    this.registerUser$ = this.authService.registerUser(body).subscribe(
      async (res: any) => {
        try {
          this.authGnx
            .signInWithCustomToken(res.gn_token, this.captcha)
            .then(async (result) => {
              const uid = this.utilsService.parseJwt(res.gn_token).uid;
              const userInfo = {
                registerDate: new Date(),
                name: String(this.f.name.value).trim(),
                lastnames: String(this.f.lastname.value).trim(),
                gnxCredential1: this.f.document.value,
                email: mail,
                phone: this.phone.controls.phone.value
                  ? this.phoneIndicator.indicator +
                    this.phone.controls.phone.value
                  : '',
                docType: this.f.documentType.value,
              };
              this.userService
                .saveUserExtraInfo(userInfo, uid)
                .then(async (setter) => {
                  try {
                    this.authGnx
                      .loginWithUserAndPassword(
                        this.LOADER_ID,
                        mail,
                        body.password,
                        this.captcha
                      )
                      .then(async (res) => {
                        console.log('loginWithUserAndPassword res ', res);
                        try {
                          console.log(
                            'loginWithUserAndPassword then start try'
                          );
                          this.router
                            .navigate(['app/home'])
                            .then((res) => {
                              console.log(
                                'res this.router.navigate(["app/home"',
                                res
                              );
                            })
                            .catch((error) => {
                              console.log(
                                'error this.router.navigate(["app/home"',
                                error
                              );
                            });
                          await this.userService.checkIfProfileComplete();
                          this.loaderService.cancelLoader(this.LOADER_ID);
                          console.log('loginWithUserAndPassword then end try');
                        } catch (error) {
                          this.loaderService.cancelLoader(this.LOADER_ID);
                          console.error(
                            'checkIfProfileComplete catch err',
                            error
                          );
                        }
                      })
                      .catch((err) => {
                        this.loaderService.cancelLoader(this.LOADER_ID);
                        console.log(
                          'this.authService.checkIfRegistered(body). catch err',
                          err
                        );
                        if (err.message) {
                          if (err.message.includes('timeout')) {
                            return this.alertService.presentAlert(
                              'Comprueba tu conexión a internet'
                            );
                          }
                          if (err.message.includes('regex')) {
                            return this.alertService.presentAlert(
                              'Valida que todos los campos cumplan los requerimientos necesarios'
                            );
                          }
                        }

                        switch (err.code) {
                          case 'auth/invalid-email':
                            this.error = 'Email invalido';
                            break;
                          case 'auth/user-disabled':
                            this.error = 'Usuario deshabilitado';
                            break;
                          case 'auth/user-not-found':
                            this.error = 'Usuario no encontrado';
                            break;
                          case 'auth/wrong-password':
                            this.error = 'Contraseña incorrecta';
                            break;
                          case 'auth/too-many-requests':
                            this.error =
                              'Demasiados intentos incorrectos. Prueba mas tarde o ingresa a recuperar contraseña';
                            break;
                          case 'USER_MULTIPLE':
                            this.error =
                              'Usuario con multiples cuentas, comunícate con tu asesor';
                            break;
                          default:
                            console.log(
                              'this.authService.checkIfRegistered(body). catch err default',
                              err
                            );
                            this.error =
                              err.error?.message == 'Server Error'
                                ? 'Error interno del servidor'
                                : JSON.stringify(err);
                            if (
                              err.error?.message == 'Server Error' &&
                              err.statusText == 'OK' &&
                              (err.url as string).includes('auth/access-jwt')
                            ) {
                              this.router
                                .navigate(['app/home'])
                                .then((res) => {
                                  console.log(
                                    'res this.router.navigate(["app/home"',
                                    res
                                  );
                                })
                                .catch((error) => {
                                  console.log(
                                    'error this.router.navigate(["app/home"',
                                    error
                                  );
                                });
                            }
                            break;
                        }
                      });
                  } catch (err) {
                    console.log(
                      'this.authService.checkIfRegistered(body). catch err',
                      err
                    );
                    this.error =
                      err.error?.message == 'Server Error'
                        ? 'Error interno del servidor'
                        : JSON.stringify(err);
                  }

                  const email = this.f.email.value;
                  this.registerForm.reset();
                  if (this.f.email.value) {
                    try {
                      this.sendVerificationMail(email);
                    } catch (error) {
                      await this.loaderService.cancelLoader(this.LOADER_ID);
                      console.error(error);
                    }
                  } else {
                    await this.loaderService.cancelLoader(this.LOADER_ID);
                  }
                })
                .catch(async (error) => {
                  await this.loaderService.cancelLoader(this.LOADER_ID);
                  console.error(
                    'catch(async (error)) saveUserExtraInfo',
                    error
                  );
                });
            })
            .catch(async (error) => {
              await this.loaderService.cancelLoader(this.LOADER_ID);
              console.error('signInWithCustomToken catch (error :', error);
            });
          //const helperJWT = new JwtHelperService();
        } catch (error) {
          await this.loaderService.cancelLoader(this.LOADER_ID);
          console.error('signInWithCustomToken catch (error :', error);
        }
      },
      (error) => {
        const err = error.error;
        this.storageService.set('error-message', err.message);
        this.loaderService.cancelLoader(this.LOADER_ID);
        switch (err.code) {
          case 'EMAIL_USED':
            this.router.navigateByUrl('register-error');
            break;
          case 'PHONE_USED':
            this.router.navigateByUrl('register-error');
            break;
          case 'ACCOUNT_DISABLED':
            this.alertService.presentAlert(
              'La cuenta se encuentra desabilitada'
            );
            break;
          case 'WRONG_CREDENTIAL':
            this.alertService.presentAlert('Usuario no registrado');
            break;
          case 'VALIDATION_ERROR':
            this.alertService.presentAlert(
              'Error de validación: ' + err.message
            );
            break;
          case 'HTTP_BAD_REQUEST':
            this.alertService.presentAlert('Error, comunicate con tu asesor');
            break;
          case 'UNAUTHORIZED':
            this.alertService.presentAlert('Código no autorizado');
            break;
          case 'HTTP_UNAUTHORIZED':
            this.alertService.presentAlert('');
            break;
          case 'WRONG_CREDENTIAL_RECAPTCHA':
            this.alertService.presentAlert(
              'Intentalo nuevamente en dos minutos'
            );
            break;
          case 'ALREADY_REGISTERED':
            this.router.navigateByUrl('register-error');
            break;
          case 'INSECURE_PASSWORD':
            this.alertService.presentAlert('Contraseña insegura');
            break;
          case 'IDDOC_USED':
            this.error = 'Documento ya registrado';
            console.log('Documento ya registrado', error);
            break;
          default:
            console.log('Código de error no identificado', error);
            break;
        }
        console.error('Error', error.error);
      }
    );
  }

  async sendVerificationMail(email) {
    const user = await this.fireAuth.currentUser;
    const actionCodeSettings = {
      url: environment.dinamycLink.url,
      android: {
        packageName: environment.dinamycLink.packageName,
        installApp: true,
        minimumVersion: '0.0.1',
      },
      handleCodeInApp: true,
      dynamicCodeInApp: environment.dinamycLink.packageName,
    };
    await user
      .sendEmailVerification()
      .then((res) => {
        this.alertService.presentAlert(
          `Para confirmar tu nueva cuenta debes visitar el link de confirmacion que enviamos a tu correo: ${email}`
        );
      })
      .catch((err) => {
        console.error('error correo', err);
      });
  }

  indicatorSelect(event) {
    const data = event.target.value;
    this.phone.controls['phone'].setValidators([
      Validators.minLength(data.minLength),
      Validators.maxLength(data.maxLength),
    ]);
    this.phone.controls['confirmPhone'].setValidators([
      Validators.minLength(data.minLength),
      Validators.maxLength(data.maxLength),
    ]);

    if (this.phoneIndicator) {
      if (data.indicator == this.phoneIndicator.indicator) {
        this.phoneIndicator = data;
      } else {
        // this.alertService.presentAlert('Selecciona el mismo indicativo');
      }
    }
    this.phoneIndicator = data;
  }

  get getTextsPageRegister() {
    return this.languageService.textsIU.page_register;
  }
}
